import React, {Component} from 'react'
import Questions from "../questions";
import SubmitButton from "../submitButton";
import './questionForm.css';
import {bindActionCreators} from "redux";
import connect from "react-redux/es/connect/connect";
import Smiles from "../smiles";
import Footer from "../footer";
import Header from "../header";
import {sendForm, voteMark} from "../../thunks";
import AlreadySent from "../alreadySent";
import Thanks from "../thanks";
import classNames from "classnames";
import Loader from 'react-loader';
import Error from "../error";

class QuestionForm extends Component {
    componentWillMount () {
        const {match: {params}} = this.props;

        if (params.mark !== undefined) {
            this.props.voteMark(parseInt(params.mark, 10), params.hash);
        }
    }

    handleVoteMark(mark) {
        const {match: {params}} = this.props;

        this.props.voteMark(mark, params.hash);
    }

    handleSubmitForm() {
        this.props.sendForm(this.props.match.params.hash);
    }

    render() {
        let body;
        let header;
        let footer

        if (!this.props.open && this.props.sent) {
            body = <Thanks/>

        } else if (this.props.open && this.props.sent) {
            body = <Error hash={this.props.match.params.hash} />

        } else if (!this.props.open) {
            body = <AlreadySent/>;

        } else if (this.props.loading) {

            body =
                <div className="QuestionForm__loading">
                    <Loader loaded={false}/>
                    <span className="QuestionForm__loading__text">{'Načítám data'}</span>
                </div>
        } else {
            header =  <Header/>;
            footer = <Footer absolute={(this.props.mark === null)}/>;

            let form;

            if (this.props.mark !== null && !this.props.loading) {
                form =
                    <div className="QuestionForm__form">
                        <Questions/>
                        <SubmitButton
                            onClick={this.handleSubmitForm.bind(this)}
                        />
                    </div>;

            }

            body =
                <div>
                    <Smiles
                        mark={this.props.mark}
                        voteMark={this.handleVoteMark.bind(this)}
                        questionsCount={this.props.questions.count()}
                        loading={this.props.loading}
                    />
                    {form}
                 </div>;

        }


        return (
            <div className={classNames({
                    'QuestionForm': true,
                    'QuestionForm--center': (this.props.loading || this.props.sent || !this.props.open ? true : false) ,
                    'QuestionForm--submit': (this.props.submit ? true : false),
                })}>
                {header}
                <div className={classNames({
                    'QuestionForm__body': true,
                    'QuestionForm__body--center': (this.props.loading || this.props.sent || !this.props.open ? true : false),
                })}>
                    {body}
                </div>
                {footer}
            </div>
         );
    }
}

const mapStateToProps = ({router, voter}) => ({
    mark: voter.get('mark'),
    open: voter.get('open'),
    sent: voter.get('sent'),
    questions: voter.get('questions'),
    loading: voter.get('loading'),
    submit: voter.get('submit'),
});

const mapDispatchToProps = dispatch => bindActionCreators({
    voteMark,
    sendForm,
}, dispatch);

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(QuestionForm);


// WEBPACK FOOTER //
// ./src/components/questionForm/index.js